import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllDocuments from "../../Components/Admin/AdminAllDocuments";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllDocumentsPage = () => {
  return (
    <AdminAllDocuments />
  );
};

export default AdminAllDocumentsPage;
